import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNewspaper3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconNewspaper3"><Path d="M21.5 4.5H2.5V19.5H21.5V4.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M5.5 15.5H18.5M12.5 12H18.5M12.5 8.5H18.5" stroke="currentColor" strokeLinecap="square"/><Path d="M9.5 8.5V12H9.125L6 8.5H5.5V12" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconNewspaper3;
